import { useCallback, useEffect, useState } from 'react';

import TextField from '@/components/FormElements/TextField';
import { ActionButton } from '@/components/Shared/Buttons';
import config from '@/configs/dybr';
import { debounce } from '@/utils/helpers/general';
import { validateName } from '@/utils/helpers/validate';

import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import { updateProfileThunk } from '@/store/user/thunks/updateProfileThunk';
import { useDispatch, useSelector } from 'react-redux';

export function NicknameSettings() {
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();
  const [token] = useTokenState();

  const profile = useSelector(state =>
    selectActiveProfileAugmented(state, { activeProfileId })
  );

  const [nickname, setNickname] = useState(profile.nickname);
  const [nicknameError, setNicknameError] = useState('');

  useEffect(() => {
    setNickname(profile.nickname);
    setNicknameError('');
  }, [profile]);

  const validateNickname = async (nickname, token) => {
    const error = await validateName(nickname, { token });
    setNicknameError(error ?? '');
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedValidate = useCallback(debounce(300, validateNickname), []);

  const updateNickname = () => {
    if (nickname !== profile.nickname) {
      dispatch(
        updateProfileThunk({ data: { nickname }, token, activeProfileId })
      );
    }
  };

  const changeNickname = e => {
    const value = e.target.value;
    setNicknameError('');
    setNickname(value);

    if (value !== profile.nickname) {
      debouncedValidate(value, token);
    }
  };

  const canSaveFirstSection =
    nickname !== (profile.nickname ?? '') && !nicknameError;

  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Смена ника</h4>
          <p>Здесь вы можете изменить ваше Дыбро-имя</p>
        </SettingSectionTitle>
        <Settings>
          <TextField
            label="никнейм"
            isRequired={true}
            onChange={changeNickname}
            maxLen={config.MAX_LENGTH.nickname}
            value={nickname}
            error={nicknameError}
            touched
          />
          {canSaveFirstSection && (
            <ActionButton onClick={updateNickname}>сохранить</ActionButton>
          )}
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}
